import SelectBox from 'components/form/SelectBox'
import { useDispatch, useSelector } from 'react-redux'
import DomainText, {
  AD_ACCOUNT,
  AD_GROUP,
  CAMPAIGN,
  CREATIVE,
  getDomainText,
  KEYWORD,
} from 'features/report/common/DomainText'
import PropTypes from 'prop-types'
import { setDomain } from 'features/report/reportAddSlice'

const DomainFilter = () => {
  const dispatch = useDispatch()
  const { domain } = useSelector(state => state.report.reportAdd.formValues)
  const onSelectDomain = v => dispatch(setDomain(v))

  return (
    <div className="single_wrap">
      <span className="ico_arr" />
      <div className="screen_out">선택옵션</div>
      <SelectBox value={domain} onValueChange={onSelectDomain} noBlurOnDefault>
        <SelectBox.Item
          value="AD_ACCOUNT"
          tiaraAction={`보고서_${getDomainText(AD_ACCOUNT)}_클릭`}>
          <DomainText value={AD_ACCOUNT} />
        </SelectBox.Item>
        <SelectBox.Item
          value="CAMPAIGN"
          tiaraAction={`보고서_${getDomainText(CAMPAIGN)}_클릭`}>
          <DomainText value={CAMPAIGN} />
        </SelectBox.Item>
        <SelectBox.Item
          value="AD_GROUP"
          tiaraAction={`보고서_${getDomainText(AD_GROUP)}_클릭`}>
          <DomainText value={AD_GROUP} />
        </SelectBox.Item>
        <SelectBox.Item
          value="KEYWORD"
          tiaraAction={`보고서_${getDomainText(KEYWORD)}_클릭`}>
          <DomainText value={KEYWORD} />
        </SelectBox.Item>
        <SelectBox.Item
          value="CREATIVE"
          tiaraAction={`보고서_${getDomainText(CREATIVE)}_클릭`}>
          <DomainText value={CREATIVE} />
        </SelectBox.Item>
      </SelectBox>
    </div>
  )
}

export default DomainFilter

DomainFilter.propTypes = {
  showAllItem: PropTypes.bool,
  onValueChange: PropTypes.func,
}
